import React, { useEffect, useState } from 'react'
import { Button, Divider, Flex, Input, message, Typography, Upload } from 'antd'

import { useNavigate, useParams } from 'react-router-dom'
import { database, storageRef } from '../../utils/firebase'
import axios from 'axios'
import TopBar from './TopBar'
import CommunicationButtons from './CommunicationButtons'

const { TextArea } = Input
const { Title, Text, Link } = Typography


const LabEdits = () => {
  const emailUrl = process.env.REACT_APP_FIREBASE_CLOUD_FUNCTION_URL + '/sendFilesWithEmail'

  const { chatID } = useParams()
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [emailBody, setEmailBody] = useState(null)
  const [files, setFiles] = useState([])
  const [patientData, setPatientDate] = useState(null)
  console.log('param', chatID,
  )
//  const navigate = useNavigate();

  const handleUpload = (info) => {
    console.log('Selected file:', info.file)
    setFiles((currentState) => ([...currentState, info.file]))

  }

  const fetchLabDetails = (chatID) => {
    database.ref(`labTracking/${chatID}`).once('value', (snapshot) => {
      const response = snapshot.val()
      console.log('response', response)
      setPatientDate(response)


    })
  }
  useEffect(() => {
    fetchLabDetails(chatID)

  }, [])

  const suggestEdits = async values => {
    try {
      setLoading(true)
      const urls = []
      // eslint-disable-next-line no-restricted-syntax
      for (const val of files) {

        const ref = storageRef().ref(
          `emailImages/${new Date().getTime()}`,
        )
        // eslint-disable-next-line no-await-in-loop
        const snapshot = await ref.put(val)
        // eslint-disable-next-line no-await-in-loop
        const str = await snapshot.ref.getDownloadURL()
        urls.push(str)
      }


      const body = `<html><body>Hi Team,<br><br>${emailBody}<br><br>Thank you for using our platform for your virtual consultation needs.<br><br>Sincerely,<br><br>   Your Doctors Online Reporting System</body></html>`
      const payload = {
        'senderEmail': 'no-reply@yourdoctors.online',
        'receiverEmails': (process.env.REACT_APP_ENVIRONMENT === 'staging') ? ['asma@yourdoctors.online'] : ['ammara@yourdoctors.online', 'prescription@yourdoctors.online'], // todo wrong triage emails
        'replyToEmail': 'asma@yourdoctors.online',
        'subject': ` for Chat ID ${chatID}`,
        'emailBody': body,
        'files': urls.map((url) => ({
          'url': url,
          'fileName': new Date().getTime(),
          'type': 'image/jpeg',
        })),
      }

      console.log('payload ', payload)

      const resp = await axios.post(emailUrl, payload)

      setLoading(false)
      message.success('Success!')

    } catch (e) {
      // eslint-disable-next-line no-undef
      alert('Something went wrong!')
      setLoading(false)
      console.log('Error', e)
    }
  }

  return (
    <div style={{ minHeight: '97vh', display: 'flex', flexDirection: 'column' }}>

      <TopBar title="Lab Edits" />
      <div style={{ flex: 1 }}>
        <Flex gap="small" style={{ padding: '10px' }}>
          <Text strong style={{ marginLeft: '10px' }}>Patient Name - {patientData?.patientName}</Text>
          <Text>{patientData?.assessment}</Text>
        </Flex>
        <Divider style={{ margin: 0 }} />

        <CommunicationButtons chatID={chatID} />
        <Flex vertical gap="small" style={{ padding: '15px' }}>
          <Text strong>Enter Details:</Text>
          <TextArea onChange={(e) => setEmailBody(e.target.value)} rows={4} placeholder="enter details" size="large" />
        </Flex>
        <Flex gap="small" vertical style={{ padding: '16px' }}>
          <Text strong>Add Attachments:</Text>
          <Upload beforeUpload={() => false} onChange={handleUpload} multiple>
            <Button style={{ borderColor: '#DF7467', color: '#DF7467' }}>Choose file</Button>
          </Upload>
        </Flex>
        <Divider />
      </div>
      <Flex gap="small" justify="center" align="center" style={{ paddingBottom: '16px' }}>
        <Button onClick={suggestEdits} type="primary" shape="round">Submit Results</Button>
      </Flex>
    </div>
  )
}
export default LabEdits
